import LoginView from './../../views/auth/LoginView.vue';
import ForgotPasswordView from './../../views/auth/ForgotPasswordView.vue';
import ResetPasswordView from './../../views/auth/ResetPasswordView.vue';

export default [
  {
    path: '/login',
    name: 'Login',
    components: { default: LoginView },
    meta: { requiresAuth: false },
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    components: { default: ForgotPasswordView },
    meta: { requiresAuth: false },
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    components: { default: ResetPasswordView },
    meta: { requiresAuth: false },
  },
];
